import { Box } from '@mui/material';
import { TextUIPart } from 'ai';
import { ReactNode } from 'react';
import { Streamdown } from 'streamdown';

import { components, allowedTags } from '../../../ChatMessage/MessageRenderer/MessageRenderer.config';
import { ChatUserMessageProps } from '../../ChatUserMessage';

export const ChatUserDefaultMessage = ({ message }: ChatUserMessageProps): ReactNode => {
  const parts = message.parts as TextUIPart[];
  return (
    <Box
      sx={(theme) => ({ backgroundColor: theme.palette.grey[200], padding: 3, borderRadius: 2, alignSelf: 'flex-end' })}
    >
      <Box sx={{ maxWidth: 'md' }}>
        <Streamdown mode="static" components={components} allowedTags={allowedTags}>
          {parts[0].text}
        </Streamdown>
      </Box>
    </Box>
  );
};
